var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app-content-block-text', { centered: _vm.data.centered }],style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.data.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }